import React from 'react';
import ManageFileSpecVM from './ManageFileSpecVM';
import { observer } from 'mobx-react';
import { Neo } from '@singularsystems/neo-react';
import { TextConstants } from '../../../Common/TextConstants';
import { EnumHelper, ModalUtils } from '@singularsystems/neo-core';
import InfoLabelHover from '../../../Common/Components/InfoLabelHover/InfoLabelHover';
import { enumFileExtension } from './FileExtensionEnum';
import { enumFileDelimiter } from './FileDelimiterEnum';

interface IManageFileSpecViewProps {
    viewModel: ManageFileSpecVM;
    onCancel: () => void;
    onSave: () => void;
}

@observer
export default class ManageFileSpecView extends React.Component<IManageFileSpecViewProps> {
    public render() {
        var viewModel = this.props.viewModel;
        return (
            <>
                {<Neo.Card title={`${viewModel.fileSpecLookupModel.staticFileSpecId === 0 ? TextConstants.Titles.AddFileSpec : TextConstants.Titles.EditFileSpec}`}>
                    <>
                        <Neo.Form
                            model={viewModel.fileSpecLookupModel}
                            validationDisplayMode={viewModel.validationModeDisplay}
                            onSubmit={() => this.props.onSave()}
                            onInvalid={this.onFormInvalid}>
                            <Neo.GridLayout lg={2}>
                                <Neo.FormGroup
                                    label={TextConstants.Labels.FileType}
                                    bind={viewModel.fileSpecLookupModel.meta.fileType}
                                    isReadOnly={viewModel.isFieldReadOnlyInd}
                                    placeholder={TextConstants.PlaceHolder.FileTypePlaceHolder} />
                            </Neo.GridLayout>
                            <Neo.FormGroup
                                label={TextConstants.Labels.Description}
                                bind={viewModel.fileSpecLookupModel.meta.description}
                                input={{ rows: 3 }}
                                isReadOnly={viewModel.isFieldReadOnlyInd}
                                placeholder={TextConstants.PlaceHolder.FileDescriptionPlaceholder} />
                            <Neo.GridLayout lg={6}>
                            <>
                                <label>{TextConstants.Labels.FileExtension}</label>
                                <Neo.DropDown 
                                    bind={viewModel.fileSpecLookupModel.meta.enumFileExtension} 
                                    select={{items: EnumHelper.asList(enumFileExtension)}} 
                                    value={viewModel.getExtensionEnumFromString(viewModel.fileSpecLookupModel.enumFileExtension) ?? undefined}
                                />
                            </>
                            <>
                                <label>{TextConstants.Labels.FileDelimiter}</label>
                                <Neo.DropDown
                                    bind={viewModel.fileSpecLookupModel.meta.enumFileDelimiter}
                                    select={{items: EnumHelper.asList(enumFileDelimiter)}}
                                    value={viewModel.getDelimiterEnumFromString(viewModel.fileSpecLookupModel.enumFileDelimiter) ?? undefined}
                                />
                            </>
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.ActiveStartDate}
                                    bind={viewModel.fileSpecLookupModel.meta.activeStartDate}
                                    isReadOnly={viewModel.updateFileSpecReadOnlyInd} />
                                <Neo.FormGroup
                                    appendText="fa-calendar"
                                    label={TextConstants.Labels.ActiveEndDate}
                                    bind={viewModel.fileSpecLookupModel.meta.activeEndDate}
                                    isReadOnly={viewModel.activeEndDateIsNull} />
                                <Neo.FormGroup
                                    className="pt-4"
                                    label="Current"
                                    bind={viewModel.fileSpecLookupModel.meta.isActiveInd}
                                    input={{ type: "switch" }}
                                    onChange={() => viewModel.toggleActiveEndDateSetToNull()} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={3}>
                                <Neo.FormGroup
                                    label={<InfoLabelHover title={TextConstants.Labels.RawTableReference} content={TextConstants.Tooltips.RawTableReferenceInfo} />}
                                    bind={viewModel.fileSpecLookupModel.meta.rawDataTableName}
                                    placeholder={TextConstants.PlaceHolder.RawTableReferencePlaceholder} />
                                <Neo.FormGroup
                                    label={<InfoLabelHover title={TextConstants.Labels.DefaultNormalisedTableReference} content={TextConstants.Tooltips.DefaultNormalisedTableReferenceInfo} />}
                                    bind={viewModel.fileSpecLookupModel.meta.rawGenericTableName}
                                    placeholder={TextConstants.PlaceHolder.DefaultNormalisedTablePlaceholder} />
                                <Neo.FormGroup
                                    label={<InfoLabelHover title={TextConstants.Labels.DefaultErrTableReference} content={TextConstants.Tooltips.DefaultErrorTableReference} />}
                                    bind={viewModel.fileSpecLookupModel.meta.errorHoldingTableName}
                                    placeholder={TextConstants.PlaceHolder.DefaultErrorTablePlaceholder} />
                            </Neo.GridLayout>
                            <Neo.GridLayout lg={6}>
                                <Neo.FormGroup label={TextConstants.Labels.ColumnCount} bind={viewModel.fileSpecLookupModel.meta.columnCount} />
                                <Neo.FormGroup label={TextConstants.Labels.ColumnHeaderStartLine} bind={viewModel.fileSpecLookupModel.meta.startColumnHeaderRead} />
                                <Neo.FormGroup label={TextConstants.Labels.ContainsColumnHeader} bind={viewModel.fileSpecLookupModel.meta.containHeaderInd} className="pt-4" />
                                <Neo.FormGroup label={TextConstants.Labels.SingleFile} bind={viewModel.fileSpecLookupModel.meta.isSingleFileInd} className="pt-4" />
                                <Neo.FormGroup
                                    label={TextConstants.Labels.IgnoreFile}
                                    bind={viewModel.fileSpecLookupModel.meta.isIgnoredInd}
                                    className="pt-4" />
                            </Neo.GridLayout>
                            <div className="row customMarginTop29 float-right pr-3">
                                <Neo.Button 
                                    variant="primary" className="ml-3 col-md-2"
                                    onClick={() => viewModel.showConfirmSaveModal()}
                                >{TextConstants.Buttons.Save}</Neo.Button>
                                <Neo.Button className="ml-3 col-md-2"
                                    onClick={() => this.props.onCancel()}
                                    variant="secondary"
                                >{TextConstants.Buttons.Cancel}</Neo.Button>
                            </div>
                        </Neo.Form>
                    </>

                </Neo.Card>
                }
                {viewModel.showConfirmSaveComponent &&  
                    <>
                        {
                            viewModel.isValid
                            &&
                            <Neo.Modal
                                title="Confirm Save"
                                bind={viewModel.meta.fileSpecLookupModel}
                                closeButton={{ text: "No", variant: "secondary", isOutline: true, onClick: () => viewModel.closeConfirmationModal() }}
                                acceptButton={{ text: "Yes", variant: "primary", onClick: () => this.onSave(viewModel)}}
                            >
                                { viewModel.fileSpecLookupModel.staticFileSpecId === 0 && !viewModel.fileSpecLookupModel.isCreatedFromPreviousVersionInd ? TextConstants.GeneralText.NewFileSpecSave : TextConstants.GeneralText.VersionOfFileSpecOverlaps }
                            </Neo.Modal>
                        }
                    </>
                }
            </>
        );
    }
    private onFormInvalid(e: React.FormEvent, justValidated?: boolean) {
        if (!justValidated) {
            ModalUtils.showMessage("Save", TextConstants.Validation.InvalidFileConfiguration);
        }
    }

    private onSave(vm: ManageFileSpecVM){
        vm.confirmSave();
        this.props.onSave();
    }
}